<template>
  <el-row>
    <el-form :model="intranetBusinessMemberRoleItemForm"
             ref="intranetBusinessMemberRoleItemRef"
             :rules="rules"
             @onSelectInfo="onSelectInfo"
             addAction="/businessIntranet/updateMemberRole.action"
             editAction="/businessIntranet/updateMemberRole.action"
             selectAction="/businessIntranet/selectMemberRoleForAdminDetail.action"
             label-width="180px"
             style="width:50%"
             v-form>
      <el-form-item label="会员名称:">
        <el-input v-model="intranetBusinessMemberRoleItemForm.name"></el-input>
      </el-form-item>
      <el-form-item label="会员说明:">
        <el-input type="textarea" v-model="intranetBusinessMemberRoleItemForm.introduce"></el-input>
      </el-form-item>
      <el-form-item label="会员价格(元):">
        <el-input type="number" v-model="intranetBusinessMemberRoleItemForm.price"></el-input>
      </el-form-item>
      <el-form-item label="会员时长(天):">
        <el-input type="number" v-model="intranetBusinessMemberRoleItemForm.memberDays"></el-input>
      </el-form-item>

      <el-form-item label="会员标签(选填):">
        <el-input v-model="intranetBusinessMemberRoleItemForm.userTag"></el-input>
      </el-form-item>

      <el-form-item label="线索权益次数:">
        <el-input type="number" v-model="intranetBusinessMemberRoleItemForm.legalCount"></el-input>
      </el-form-item>

      <el-form-item label="人脉个数:">
        <el-input type="number" v-model="intranetBusinessMemberRoleItemForm.contactsCount"></el-input>
      </el-form-item>

      <el-form-item label="加群个数:">
        <el-input type="number" v-model="intranetBusinessMemberRoleItemForm.groupCount"></el-input>
      </el-form-item>

      <el-form-item label="同行车源拨打次数/天:">
        <el-input type="number" v-model="intranetBusinessMemberRoleItemForm.secondDialCount"></el-input>
      </el-form-item>
      <el-form-item label="朋友圈车源拨打次数/天:">
        <el-input type="number" v-model="intranetBusinessMemberRoleItemForm.friendDialCount"></el-input>
      </el-form-item>
      <el-form-item label="同行求购拨打次数/天:">
        <el-input type="number" v-model="intranetBusinessMemberRoleItemForm.searchDialCount"></el-input>
      </el-form-item>

      <el-form-item label="微店详情私聊人数/天:">
        <el-input type="number" v-model="intranetBusinessMemberRoleItemForm.imCount"></el-input>
      </el-form-item>

      <el-form-item label="赠送推广通(元)：" prop="spreadCanUsedMoney">
        <el-input type="number" v-model="intranetBusinessMemberRoleItemForm.spreadCanUsedMoney" ></el-input>
      </el-form-item>

      <el-form-item label="会员权限:">
        <el-select multiple v-model="intranetBusinessMemberRoleItemForm.permissions" @change="handleSelectOption" placeholder="请选择">
          <el-option-group
              v-for="group in permissionsOptions"
              :key="group.label"
              :label="group.label">
            <el-option
                v-for="item in group.permissionsOptions"
                :key="item.value"
                :label="item.label"
                :value="item">
            </el-option>
          </el-option-group>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary">确定</el-button>
        <el-button @click="$router.back()">取消</el-button>
      </el-form-item>
    </el-form>
  </el-row>
</template>

<script>
import BasicPager from '@/mixins/BasicPager'

export default {
  name: 'intranetBusinessMemberRoleItem',
  extends: BasicPager,
  components: {},
  data: function () {
    var checkPriceSpread = (rule, value, callback) => {
      if (value < 0 || value > 2000) {
        return callback(new Error('请填写0-2000元之间的整数（单位元）'))
      }
      callback()
    }
    return {
      rules: {

        spreadCanUsedMoney: [{
          required: true,
          message: '请输入赠送推广通金额(元)'
        }, {
          validator: checkPriceSpread,
          trigger: 'blur'
        }]
      },
      permissionsOptions: [{
        label: '个人车源',
        permissionsOptions: [{
          value: 'grcy_ckxsxq',
          label: '查看线索详情'
        },
        {
          value: 'grcy_xsgtcz',
          label: '线上沟通车主'
        }, {
          value: 'grcy_dhlxcz',
          label: '电话联系车主'
        }, {
          value: 'grcy_sdkc',
          label: '锁定看车'
        }, {
          value: 'grcy_zqxs',
          label: '专区线索'
        }
        ]
      }, {
        label: '同行车源',
        permissionsOptions: [{
          value: 'thcy_kqls',
          label: '开启零售'
        }, {
          value: 'thcy_kqwxts',
          label: '开启微信推送'
        }]
      },
      {
        label: '朋友圈车源',
        permissionsOptions: [
          { value: 'pyqcy_pyqzdtb',
            label:
                '朋友圈自动同步' },
          { value: 'pyqcy_pfpyq',
            label: '批发朋友圈' }
        ]
      }, {
        label: '同行求购',
        permissionsOptions: [
          { value: 'thqg_kqwxts', label: '开启微信推送' }
        ]
      }, {
        label: '增值服务',
        permissionsOptions: [
          { value: 'zzfw_clgj', label: '车辆估价' },
          { value: 'zzfw_cxsb', label: '车型识别' }
        ]
      }
      ],
      intranetBusinessMemberRoleItemForm: {
        id: null,
        name: null,
        introduce: null,
        price: null,
        legalCount: null,
        secondDialCount: null,
        friendDialCount: null,
        searchDialCount: null,
        permissions: null,
        memberDays: null,
        groupCount: null,
        contactsCount: null,
        userTag: null,
        imCount: null,
        spreadCanUsedMoney: null
      },
      targetArray: []

    }
  },
  created () {
    this.intranetBusinessMemberRoleItemForm.id = this.$route.query.id
  },
  methods: {
    handleSelectOption: function (opt) {
      this.targetArray = opt
    },
    onFilterParams: function (params) {
      params.permissions = null
      params.spreadCanUsedMoney = parseInt(params.spreadCanUsedMoney * 100)
      params.permissions = JSON.stringify(this.targetArray)
    },
    onSelectInfo: function (dataInfo) {
      this.intranetBusinessMemberRoleItemForm.permissions = dataInfo.datas.permissions
      this.intranetBusinessMemberRoleItemForm.spreadCanUsedMoney = parseInt(dataInfo.datas.spreadCanUsedMoney / 100)
      this.targetArray = dataInfo.datas.permissions
    }
  },
  filters: {}

}
</script>

<style scoped>

</style>
